var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "asset-actions-footer" },
    [
      _c(
        "BaseButton",
        {
          attrs: { underlined: "" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v(" Voltar ")]
      ),
      _vm.showSerieHistorica
        ? _c(
            "BaseButton",
            {
              attrs: { dark: "", outline: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("open-serie-historica", _vm.asset)
                }
              }
            },
            [
              _c("icon-svg", { attrs: { name: "chart-grow", size: 16 } }),
              _vm._v(" Série histórica ")
            ],
            1
          )
        : _vm._e(),
      _vm.showEditAtivo
        ? _c(
            "BaseButton",
            {
              attrs: { dark: "", outline: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("edit-asset", _vm.asset)
                }
              }
            },
            [
              _c("icon-svg", { attrs: { name: "edit-pencil", size: 16 } }),
              _vm._v(" Editar ativo ")
            ],
            1
          )
        : _vm._e(),
      _vm.showEditComposicao
        ? _c(
            "BaseButton",
            {
              attrs: { dark: "", outline: "" },
              on: {
                click: function($event) {
                  return _vm.$emit("edit-composicao", _vm.asset)
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: { name: "mdi-clipboard-list-outline", size: 16 }
              }),
              _vm._v(" Editar composição ")
            ],
            1
          )
        : _vm._e(),
      _c(
        "BaseButton",
        {
          attrs: { dark: "", outline: "" },
          on: {
            click: function($event) {
              return _vm.$emit("open-asset-events")
            }
          }
        },
        [
          _c("icon-svg", { attrs: { name: "plus", size: 16 } }),
          _vm._v(" Evento ")
        ],
        1
      ),
      _c(
        "BaseButton",
        {
          attrs: { primary: "" },
          on: {
            click: function($event) {
              return _vm.$emit("open-movimentacoes", _vm.asset)
            }
          }
        },
        [
          _c("icon-svg", { attrs: { name: "plus", size: 16 } }),
          _vm._v(" Movimentação ")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }